import { render, staticRenderFns } from "./AuthorizedRequestorSubmit.vue?vue&type=template&id=d48ca50c"
import script from "./AuthorizedRequestorSubmit.vue?vue&type=script&lang=js"
export * from "./AuthorizedRequestorSubmit.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedRequestorSubmit.vue?vue&type=style&index=0&id=d48ca50c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports